// OBSOLETE: replaced with RoleEum

import { env } from "../../configs/reexports";

import skuMapJson from "./skus.json";

export interface ISkuSubComponent {
  name: string;
  type: string; // "AGX" | "CH4" | "OPT" | "THM" | "LWOP" | "VOC" | "POE"
  makeModelId: string;
  hasPT: boolean;
  hasZoom: boolean;
}

export interface ISkuDefinition {
  productName: string;
  shortName: string;
  acronym: string; // Short acronym for device naming (e.g., "mp" for Minerva Pro)
  nodeCount: number;
  subComponents: ISkuSubComponent[];
}

export const skuCatalog: Record<string, ISkuDefinition> =
  skuMapJson as unknown as Record<string, ISkuDefinition>;

// Flat { skuNumber → productName } for existing consumers
export const skuMap: Record<string, string> = Object.fromEntries(
  Object.entries(skuCatalog).map(([k, v]) => [k, v.productName])
);

// TODO: remove after testing
export const enum AccountTypeEnum {
  ADMIN = "ADMIN",
  CUSTOMER = "CUSTOMER",
  PARTNER = "PARTNER",
  CC_ADMIN = "CC ADMIN",
  CC_OPS_ADMIN = "CC OPS ADMIN",
  CC_OPS = "CC OPS",
  CC_SALES = "CC SALES",
  PARTNER_ADMIN = "PARTNER ADMIN",
  PARTNER_USER = "PARTNER USER",
  CUSTOMER_ADMIN = "CUSTOMER ADMIN",
  CUSTOMER_OPERATOR_FOREMAN = "CUSTOMER OPERATOR FOREMAN",
  OPERATOR_READ_ONLY = "CUSTOMER OPERATOR FOREMAN READ ONLY",
  CUSTOMER_OPS_TEAM = "CUSTOMER OPS TEAM",
  CUSTOMER_HSE = "CUSTOMER HSE",
  CUSTOMER_SERCURITY = "CUSTOMER SECURITY",
  CC_PROCTORS = "CC PROCTORS",
  PENDING_CUSTOMER = "PENDING CUSTOMER",
  VERIFIER = "VERIFIER",
}

export enum RouteEnum {
  Empty = "void", // used for expanding the menu items in the left sidebar

  Home = "/",
  HomePlatform = "/platform",
  Login = "/login",
  PendingUser = "/pending-user",
  Unauthorized = "/unauthorized",
  Success = "/success",
  AppOld = "old",
  Minerva = "/minerva",
  NothingHerePage = "*",

  Products = "/products",
  SystemSettings = "/system-settings",
  DeploymentHealth = "/deployment-health",
  SystemHealth = "/system-health",
  EmailNotifications = "/email-notifications",

  Integrations = "/system-settings/integrations",
  IntegrationsAzure = "/integrations/azure",
  IntegrationsS3 = "/integrations/s3",
  IntegrationsEdge = "/integrations/edge",

  RecentActivities = "/recent-activities",
  ControlRoom = "/control-room",
  LiveView = "/live-view",
  ZoneList = "/live-view/zones-list/:deviceId",
  ZoneListShort = "/live-view/zones-list",
  CreateZone = "/recent-activities/create-zone",
  EditEventDetails = "/control-room/edit-event-details/:eventId",

  Telemetry = "/telemetry",
  TelemetryTankLevel = "/telemetry/tlm",
  TelemetryGateGuard = "/telemetry/agg",
  TelemetryPeopleAndVehicle = "/telemetry/peopleandvehicle",
  TelemetryHardHat = "/telemetry/hardhat",

  GasLeak = "/recent-activities/gasleak",
  FireSmoke = "/recent-activities/firesmoke",
  Fire = "/recent-activities/fire",
  Smoke = "/recent-activities/smoke",
  HardHat = "/recent-activities/hardhat",
  Agg = "/recent-activities/agg",
  Tlm = "/recent-activities/tlm",
  LiquidLeak = "/recent-activities/liquidleak",

  CustomerSettings = "/customer-settings",
  SettingsPage = ":tabId",

  ManageLocations = "manage-locations",
  CreateLocation = "/manage-locations/create",
  EditLocation = "manage-locations/edit",
  EditLocationPageLocationId = "/manage-locations/edit/:locationId",

  AlertManagement = "alert-management",
  AdminNavigation = "admin-navigation",
  CreateAlert = "alert-management/create",

  Nodes = "/nodes",
  CreateNode = "/nodes/create",

  Devices = "/devices",
  DevicesPageLocationId = "/devices/:locationId",
  DevicesPageNodeId = "/devices/:nodeId",
  Device = "/device/:deviceId",
  CreateDevice = "/devices/create",
  ZoneSetup = "/devices/zone-setup",
  CreateDeviceZone = "/device/create-zone",
  EditDevice = "/device/edit/:deviceId",
  CreateDeviceZoneDeviceId = "/device/:deviceId/create-zone",
  EditZoneDeviceIdZoneId = "/device/:deviceId/:zoneId/edit-zone",
  ZoneOverviewPageDeviceIdZoneId = "/device/:deviceId/:zoneId",

  Model = "/model",
  CreateModel = "/model/create",
  AddModelPage = "/device/:deviceId/add-model/:modelToRun",
  OverviewModelPage = "/device/:deviceId/model/:modelType",

  Statistics = "/statistics",
  SystemPerformance = "/statistics/system-performance",
  FeedbackInsights = "/statistics/feedback-insights",

  Sensory = "/sensory",
  SensoryRecentActivities = "/sensory/recent-activities",
  SensoryControlRoom = "/sensory/control-room",
  SensoryEditEventDetails = "/sensory/control-room/edit-event-details/:eventId",
  SensoryDataModel = "/sensory/recent-activities/:model",
  SensoryLiveView = "/sensory/live-view",
  SensoryLiveViewZoneList = "/sensory/live-view/zones-list/:deviceId",
  SensoryLiveViewZoneListShort = "/sensory/live-view/zones-list",
  SensoryDeploymentHealth = "/sensory/deployment-health",
  SensorySystemHealth = "/sensory/system-health",
  SensorySystemSettings = "/sensory/system-settings",
  SensoryEditLocation = "/sensory/manage-locations/edit/",
  SensoryStatistics = "/sensory/statistics",

  SensoryTelemetry = "/sensory/telemetry",
  SensoryTelemetryTlm = "/sensory/telemetry/tlm",
  SensoryTelemetryAgg = "/sensory/telemetry/agg",
  SensoryTelemetryPeopleAndVehicle = "/sensory/telemetry/peopleandvehicle",
  SensoryTelemetryHardHat = "/sensory/telemetry/hardhat",

  SensoryIntegrations = "/sensory/system-settings/integrations",
  SensoryIntegrationsAzure = "/sensory/integrations/azure",
  SensoryIntegrationsS3 = "/sensory/integrations/s3",
  SensoryIntegrationsEdge = "/sensory/integrations/edge",

  SensoryGasLeak = "/sensory/recent-activities/gasleak",
  SensoryFireSmoke = "/sensory/recent-activities/firesmoke",
  SensoryFire = "/sensory/recent-activities/fire",
  SensorySmoke = "/sensory/recent-activities/smoke",
  SensoryHardHat = "/sensory/recent-activities/hardhat",
  SensoryLiquidLeak = "/sensory/recent-activities/liquidleak",

  TelemetryAggPlatesManagement = "/telemetry/agg/plates-management",
  TelemetryAggPlatesManagementPauseAlerts = "/telemetry/agg/plates-management/pause-alerts",
  TelemetryAggPlatesManagementCreatePlateNumber = "/telemetry/agg/plates-management/create-plate-number",
  TelemetryAggPlatesManagementEditPlateNumber = "/telemetry/agg/plates-management/edit-plate-number",
  TelemetryAggPlatesManagementEditCategory = "/telemetry/agg/plates-management/edit-category",
  SystemSettingsPlatesManagementCreatePlateNumber = "/system-settings/create-plate-number",

  SensoryTelemetryAggPlatesManagement = "/sensory/telemetry/agg/plates-management",
  SensoryTelemetryAggPlatesManagementPauseAlerts = "/sensory/telemetry/agg/plates-management/pause-alerts",
  SensoryTelemetryAggPlatesManagementCreatePlateNumber = "/sensory/telemetry/agg/plates-management/create-plate-number",
  SensoryTelemetryAggPlatesManagementEditPlateNumber = "/sensory/telemetry/agg/plates-management/edit-plate-number",
  SensoryTelemetryAggPlatesManagementEditCategory = "/sensory/telemetry/agg/plates-management/edit-category",
  SensorySystemSettingsPlatesManagementCreatePlateNumber = "/sensory/system-settings/create-plate-number",

  HumanValidator = "/human-validator",

  LeakFinder = "/leak-finder",
  LeakFinderClientUploads = "/leak-finder/client-uploads",
  LeakFinderClientUploadsCreate = "/leak-finder/client-uploads/create",
  LeakFinderClientUploadsEditClient = "/leak-finder/client-uploads/edit-client",
  LeakFinderClientUploadsEditGroup = "/leak-finder/client-uploads/edit-group",
  LeakFinderUploadNewVideoGroupPage = "/leak-finder/new-video-group",
  LeakFinderUserPreferences = "/leak-finder/user-preferences",

  MediaViewer = "/media/:base64/:bucketKey",
}

export const AuthPaths = {
  Marketplace: `https://${env.stacks.webapp.appsUrl}/marketplace`,
  Luminary: `https://${env.stacks.webapp.appsUrl}/luminary`,
  EnerGPT: `https://${env.stacks.webapp.appsUrl}/ener-gpt`,
  CIintelligence: `https://${env.stacks.webapp.appsUrl}/ci-intelligence`,
  Administration: `https://${env.stacks.webapp.authUrl}`,
};

export type AccountType =
  | AccountTypeEnum.ADMIN
  | AccountTypeEnum.CUSTOMER
  | AccountTypeEnum.PARTNER
  | AccountTypeEnum.CC_ADMIN
  | AccountTypeEnum.CC_OPS_ADMIN
  | AccountTypeEnum.CC_OPS
  | AccountTypeEnum.CC_SALES
  | AccountTypeEnum.PARTNER_ADMIN
  | AccountTypeEnum.PARTNER_USER
  | AccountTypeEnum.CUSTOMER_ADMIN
  | AccountTypeEnum.CUSTOMER_OPERATOR_FOREMAN
  | AccountTypeEnum.OPERATOR_READ_ONLY
  | AccountTypeEnum.CUSTOMER_OPS_TEAM
  | AccountTypeEnum.CUSTOMER_HSE
  | AccountTypeEnum.CUSTOMER_SERCURITY
  | AccountTypeEnum.CC_PROCTORS
  | AccountTypeEnum.PENDING_CUSTOMER
  | AccountTypeEnum.VERIFIER;

export enum RoleEnum {
  ROOT = "R#ROOT",
  CC_OPS_ADMIN = "R#CC_OPS_ADMIN",
  CC_OPS = "R#CC_OPS",
  CC_SALES = "R#CC_SALES",
  PARTNER_ADMIN = "R#PARTNER_ADMIN",
  PARTNER_USER = "R#PARTNER_USER",
  CUSTOMER_ADMIN = "R#CUSTOMER_ADMIN",
  CUSTOMER_OPERATOR_FOREMAN = "R#CUSTOMER_OPERATOR_FOREMAN",
  OPERATOR_READ_ONLY = "R#OPERATOR_READ_ONLY",
  CUSTOMER_OPS_TEAM = "R#CUSTOMER_OPS_TEAM",
  CUSTOMER_HSE = "R#CUSTOMER_HSE",
  CUSTOMER_SECURITY = "R#CUSTOMER_SECURITY",
  CC_PROCTORS = "R#HUMAN_VALIDATOR",
  LEAKFINDER_DIRECTOR = "R#LEAKFINDER_DIRECTOR",
  PENDING = "R#PENDING",
  VERIFIER = "R#VERIFIER",
  NONE = "",
}

export const CC_ADMIN_ROLES = [
  RoleEnum.ROOT,
  RoleEnum.CC_OPS_ADMIN,
  RoleEnum.CC_OPS,
  RoleEnum.CC_SALES,
  RoleEnum.PARTNER_ADMIN,
  RoleEnum.PARTNER_USER,
  RoleEnum.VERIFIER,
];

export const ROLES = [
  RoleEnum.ROOT,
  RoleEnum.CC_OPS_ADMIN,
  RoleEnum.CC_OPS,
  RoleEnum.CC_SALES,
  RoleEnum.PARTNER_ADMIN,
  RoleEnum.PARTNER_USER,
  RoleEnum.CUSTOMER_ADMIN,
  RoleEnum.CUSTOMER_OPERATOR_FOREMAN,
  RoleEnum.OPERATOR_READ_ONLY,
  RoleEnum.CUSTOMER_OPS_TEAM,
  RoleEnum.CUSTOMER_HSE,
  RoleEnum.CUSTOMER_SECURITY,
  RoleEnum.CC_PROCTORS,
  RoleEnum.LEAKFINDER_DIRECTOR,
  RoleEnum.PENDING,
  RoleEnum.VERIFIER,
];

export enum ModelsEnum {
  AllEvents = "All events",
  GasVolumes = "Gas Volumes",
  PPEInfractions = "PPE Infractions",
  Visitors = "Visitors",
  MostActive = "Most active",
}

export enum LeftMenuItems {
  DEVICES = "Devices",
  AI_MANAGER = "AI manager",
  NODES = "Nodes",
  TELEMETRY = "Telemetry",
  TANK_LEVEL = "Tank level",
  PEOPLE_AND_VEHICLE = "People and Vehicle",
  HARD_HAT = "Hard hat",
  GATE_GUARD = "Gate guard",
  CUSTOMER_SETTINGS = "Customer settings",
  RECENT_ACTIVITIES = "Recent activities",
  CONTROL_ROOM_BETA = "Control room",
  LIVE_VIEW = "Live view",
  DEPLOYMENT_HEALTH = "Deployment health",
  SYSTEM_HEALTH = "System health",
  STATISTICS = "Statistics",
  SYSTEM_SETTINGS = "System settings",
}

export enum VideoStatusEnum {
  NOT_RETRIEVED = "NOT_RETRIEVED",
  RETRIEVING = "RETRIEVING",
  RETRIEVED = "RETRIEVED",
}
